import { render, staticRenderFns } from "./Accessibility.vue?vue&type=template&id=47b96d28&scoped=true&"
import script from "./Accessibility.vue?vue&type=script&lang=js&"
export * from "./Accessibility.vue?vue&type=script&lang=js&"
import style0 from "./Accessibility.vue?vue&type=style&index=0&id=47b96d28&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b96d28",
  null
  
)

export default component.exports